import {
  Companion_getInstance3newi3yfn54ei as Companion_getInstance,
  ChangeRequestInfo190hcn8381h6v as ChangeRequestInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareChangeRequestInfoFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ChangeRequestInfo_id_getInstance(), ChangeRequestInfo_itemNumber_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function ChangeRequestInfo_id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ChangeRequestInfo_id$_get_name_$ref_psds7u() {
  return (p0) => p0.i20();
}
function ChangeRequestInfo_id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequestInfo_id$_get_serializer_$ref_h0dgox() {
  return (p0) => p0.h2j();
}
function ChangeRequestInfo_id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ChangeRequestInfo_id$_get_annotations_$ref_otlztx() {
  return (p0) => p0.bz();
}
var ChangeRequestInfo_idClass;
function ChangeRequestInfo_id() {
  if (ChangeRequestInfo_idClass === VOID) {
    class $ {
      constructor() {
        ChangeRequestInfo_id_instance = this;
        var tmp = this;
        tmp.t5a_1 = lazy(ChangeRequestInfo_id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u5a_1 = lazy(ChangeRequestInfo_id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v5a_1 = lazy(ChangeRequestInfo_id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.t5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequestInfo_id$_get_name_$ref_psds7u(), null);
        return tmp0.f2();
      }
      w5a(receiver) {
        return receiver.x5a_1;
      }
      k2j(receiver) {
        return this.w5a(receiver instanceof ChangeRequestInfo() ? receiver : THROW_CCE());
      }
      z5a(receiver, value) {
        return receiver.a5b(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequestInfo() ? receiver : THROW_CCE();
        return this.z5a(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequestInfo_id$_get_serializer_$ref_h0dgox(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v5a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequestInfo_id$_get_annotations_$ref_otlztx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequestInfo_id', VOID, VOID, [SerializableProperty()]);
    ChangeRequestInfo_idClass = $;
  }
  return ChangeRequestInfo_idClass;
}
var ChangeRequestInfo_id_instance;
function ChangeRequestInfo_id_getInstance() {
  if (ChangeRequestInfo_id_instance === VOID)
    new (ChangeRequestInfo_id())();
  return ChangeRequestInfo_id_instance;
}
function ChangeRequestInfo_itemNumber$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ChangeRequestInfo_itemNumber$_get_name_$ref_g6fy5h() {
  return (p0) => p0.i20();
}
function ChangeRequestInfo_itemNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ChangeRequestInfo_itemNumber$_get_serializer_$ref_vlbwse() {
  return (p0) => p0.h2j();
}
function ChangeRequestInfo_itemNumber$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ChangeRequestInfo_itemNumber$_get_annotations_$ref_v60lq2() {
  return (p0) => p0.bz();
}
var ChangeRequestInfo_itemNumberClass;
function ChangeRequestInfo_itemNumber() {
  if (ChangeRequestInfo_itemNumberClass === VOID) {
    class $ {
      constructor() {
        ChangeRequestInfo_itemNumber_instance = this;
        var tmp = this;
        tmp.b5b_1 = lazy(ChangeRequestInfo_itemNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5b_1 = lazy(ChangeRequestInfo_itemNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5b_1 = lazy(ChangeRequestInfo_itemNumber$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ChangeRequestInfo_itemNumber$_get_name_$ref_g6fy5h(), null);
        return tmp0.f2();
      }
      w5a(receiver) {
        return receiver.y5a_1;
      }
      k2j(receiver) {
        return this.w5a(receiver instanceof ChangeRequestInfo() ? receiver : THROW_CCE());
      }
      e5b(receiver, value) {
        return receiver.a5b(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ChangeRequestInfo() ? receiver : THROW_CCE();
        return this.e5b(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ChangeRequestInfo_itemNumber$_get_serializer_$ref_vlbwse(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ChangeRequestInfo_itemNumber$_get_annotations_$ref_v60lq2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ChangeRequestInfo_itemNumber', VOID, VOID, [SerializableProperty()]);
    ChangeRequestInfo_itemNumberClass = $;
  }
  return ChangeRequestInfo_itemNumberClass;
}
var ChangeRequestInfo_itemNumber_instance;
function ChangeRequestInfo_itemNumber_getInstance() {
  if (ChangeRequestInfo_itemNumber_instance === VOID)
    new (ChangeRequestInfo_itemNumber())();
  return ChangeRequestInfo_itemNumber_instance;
}
//region block: exports
export {
  prepareChangeRequestInfoFields as prepareChangeRequestInfoFields32aye1bigimpf,
};
//endregion

//# sourceMappingURL=ChangeRequestInfoFields.mjs.map
